export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/ad_copy.11ff0a6.svg";